import React from 'react'

/**
 * @function SortControl
 * 
 * @param {Array} sorts
 * 
 * A basic sort control over an array of string, calls back with selected string onChange
 * 
 **/
const SortControl = ({ sorts, callback }) => {
  const onChange = (event) => {
    const value = event.target.value
    callback(value)
  }

  return <div className='select is-small filter-sort ml-2'>
      <select defaultValue={sorts.at(0) ?? ''}
              onChange={onChange} >
        { sorts.map((sort, index) => <option key={index} value={sort}>{sort}</option>) }
      </select>
    </div>
}

export default SortControl